// extracted by mini-css-extract-plugin
export default {"isGeneratingContainer":"DetectionBanner_isGeneratingContainer__cV0E2"};